const WLCommon = {
  enableLoading: function() {
    document.body.classList.add('unico-loading');
  },

  disableLoading: function() {
    document.body.classList.remove('unico-loading');
  }
};

window.WLCommon = WLCommon;

const WLCartUpdate = {
  excludeNames: ['checkout'],
  init: function() {
    this.target = document.querySelector('#cart');
    if (!this.target) {
      console.warn('Cart form not found');
      return;
    }
    this.formData = new FormData(this.target)
    this.filteredFormData = this.removeEntries();
    if(!this.target) return;
    // デバッグ処理
    this.filteredFormData.forEach((value, key) => {
      // console.log(key, value);
    });

    // 送信処理
    this.send();
  },
  removeEntries: function() {
    this.filteredFormData = new FormData();
    this.formData.forEach((value, key) => {
      if (!this.excludeNames.includes(key)) {
        this.filteredFormData.append(key, value);
      }
    });
    return this.filteredFormData;
  },
  send: function() {
    fetch('/cart', {
      method: 'POST',
      body: this.filteredFormData
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      // console.log(JSON.parse(data.attributes.BODY))
    })
    .catch(error => {
      console.error('Error updating cart:', error);
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  document.body.addEventListener('click', function(event) {
    if (event.target.closest('.unico-loading')) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);
});
